import { apiUtils } from '../utils/apiUtils'

const jsonHeaders = { 'Content-Type': 'application/json' }

export default {
  get: function () {
    return fetch(apiUtils.client + '/contact/', {
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) {
        return res.json()
      } else if (res.status === 404) {
        return { error: 'Aucun contact trouvé' }
      }
      return Promise.resolve({})
    })
  },
  getById: function (id) {
    return fetch(apiUtils.client + '/contact/' + id, {
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) {
        return res.json()
      } else if (res.status === 404) {
        return { error: 'Aucun contact trouvé' }
      }
      return Promise.resolve({})
    })
  },
  upsert: function (idcontact, contact, clientid) {
    const id = idcontact !== '' && idcontact != null ? idcontact : 'none'
    return fetch(apiUtils.client + '/contact/' + id + '/' + clientid, {
      method: 'PUT',
      headers: jsonHeaders,
      body: JSON.stringify(contact)
    })
  },
}
